import { useTranslation } from "react-i18next";
import { DesktopDialog } from "../app/DesktopDialog";
import { JuisciPrivacyPolicy } from "./JuisciPrivacyPolicy";

/**
 * The privacy policy of Juisci in a dialog over the last onboarding step of a
 * desktop (Figma D7, 5588:237192), so that reading it never leaves the
 * signup. Never over another modal: the settings open their own policy page.
 * The title stays while the long text scrolls under it.
 */
export function PrivacyPolicyDialog({
  onClose,
}: {
  onClose: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <DesktopDialog
      presentation="modal"
      title={t("Privacy policy")}
      header={{ layout: "inline" }}
      subtitle={null}
      onClose={onClose}
      footer={null}
    >
      <div className="w-full">
        <JuisciPrivacyPolicy />
      </div>
    </DesktopDialog>
  );
}
